import { Component, OnInit } from '@angular/core';
import {BannersService} from '../../services/banners.service';
import {DomSanitizer} from '@angular/platform-browser';
import {PromosService} from '../../services/promos.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {GoogleAnalyticsService} from 'mugan86-ng-google-analytics';
import {ParamsService} from '../../services/params.service';
import {ShowCardService} from '../../services/ShowCard.service';
import {PromoResult} from '../../models/promoresult.model';
import {Promo} from '../../models/promo.model';
import {Page} from '../../models/page.model';
import {ConfigKeys} from '../../config/config.keys';
import {Subscription} from 'rxjs';
import {FilteroffersService} from '../../services/filteroffers.service';
import {Filter} from '../../models/filter.model';
import {CampaignsService} from '../../services/campaigns.service';
import {Campaign} from '../../models/campaign.model';

@Component({
  selector: 'app-camp-promos',
  templateUrl: './camp-promos.component.html',
  styleUrls: ['./camp-promos.component.css']
})
export class CampPromosComponent implements OnInit {

  configKeys: ConfigKeys = new ConfigKeys();

  promos: Promo[] = [];
  promosMobile: Promo[] = [];
  currentPage: number = 0;
  disabledOnPrevButton = true;
  disabledOnNextButton = false;
  pages: Page[] = [];
  // selectedIdCard: number = 0;

  subscription: Subscription;

  // filter: Filter = new Filter(0, '', -1, -1);

  selectedPage: number = 1;

  campaign: Campaign = new Campaign(-1,'', '','','','', new Date(), new Date(), '', 0 );
  idCamp: number = -1;

  constructor(
    private bannersService: BannersService,
    private sanitizer: DomSanitizer,
    private promosService: PromosService,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public googleAnalyticsService: GoogleAnalyticsService,
    private paramsService: ParamsService,
    private filterOffersService: FilteroffersService,
    private showCardService: ShowCardService,
    private campaignService: CampaignsService
  ) {

    this.subscription = this.filterOffersService.getSelectedFilter().subscribe(filter => {


      this.spinner.show();
      //console.log('FILTRO DE PROMOCIONES(subscriber): [' + filter.state + '],[' + filter.zoneId + '],[' + filter.categoryId + '],[' + filter.keyWord + '],[' + filter.cardType + ']');

     /* this.filter.idCard =  filter.idCard;
      this.filter.keyWord = filter.keyWord;
      this.filter.categoryId = filter.categoryId;
      this.filter.stateId = filter.stateId;*/

      this.showPage(1);
      this.getMobilePromos();

    });

  }

  ngOnInit() {


    this.idCamp = this.route.snapshot.params['idCamp'];

  this.campaignService.getCampaign(this.idCamp.toString()).subscribe((campaign: Campaign) => {

    this.campaign = campaign;
    this.campaignService.setCampaign(campaign);

  });


    // var idCard = this.route.snapshot.params['cardId'];
    // var idCard = 3;
    // this.selectedIdCard = idCard;
    // this.filter.idCard = this.selectedIdCard;


    this.selectedPage = this.route.snapshot.params['page'];

    if(this.selectedPage===0 || this.selectedPage===undefined)
      this.currentPage=1;
    else
      this.currentPage=this.selectedPage;

    /** spinner starts on init */
    this.spinner.show();
    this.promosService.getPromosByCamp(this.idCamp, this.currentPage)
      .subscribe(
        (promoResult: PromoResult) => {

          //  console.log('promoResult -> records: ' + promoResult.records);
          //  console.log('promoResult -> pages: ' + promoResult.pages);
          //  console.log('promoResult -> COUNT: ' + promoResult.count);
          //  console.log('promoResult -> hasPrev: ' + promoResult.hasPrevPage);
          //  console.log('promoResult -> hasNext: ' + promoResult.hasNextPage);

          this.promos = promoResult.promotions;
          this.promosService.setPromos(promoResult.promotions);

          this.setPagination(this.currentPage, promoResult.pages);
          this.spinner.hide();
        }
      );

    this.promosService.getPromosByCampAll(this.idCamp)
      .subscribe(
        (promoResult: PromoResult) => {

          //console.log('promoResult -> records: ' + promoResult.records);
          //console.log('promoResult -> pages: ' + promoResult.pages);
          //console.log('promoResult -> COUNT: ' + promoResult.count);
          //console.log('promoResult -> hasPrev: ' + promoResult.hasPrevPage);
          //console.log('promoResult -> hasNext: ' + promoResult.hasNextPage);

          this.promosMobile = promoResult.promotions;
          this.promosService.setPromosMobile(promoResult.promotions);

        }
      );

  }


  setPagination(pageNumber:  number, totalPages: number){

    this.pages.splice(0, this.pages.length);

    var i: number;
    for(i=1; i<=totalPages; i++)
      this.pages.push(new Page(i, i==pageNumber ? this.configKeys.ICON_ACTIVE_PAGE : this.configKeys.ICON_INACTIVE_PAGE));

  }

  onPrevPage(){

    if(this.currentPage===1)
      return;

    this.currentPage =  this.currentPage - 1;
    var pageNumber = this.currentPage;

    //console.log('Displaying page: ' + pageNumber);

    this.spinner.show();
    this.promosService.getPromosByCamp(this.idCamp, pageNumber)
      .subscribe(
        (promoResult: PromoResult) => {
          //console.log('promoResult -> COUNT: ' + promoResult.count);
          //console.log('promoResult -> hasPrev: ' + promoResult.hasPrevPage);
          //console.log('promoResult -> hasNext: ' + promoResult.hasNextPage);
          this.promos = promoResult.promotions;
          this.promosService.setPromos(promoResult.promotions);

          if(promoResult.hasPrevPage)
          {
            this.disabledOnPrevButton=false;
          }
          else{
            this.disabledOnPrevButton=true;
          }

          this.disabledOnNextButton = !promoResult.hasNextPage;

          this.setPagination(pageNumber, promoResult.pages);
          this.spinner.hide();
        }
      );

  }

  onNextPage(){


    if(this.currentPage===this.pages.length)
      return;

    this.currentPage = Number(this.currentPage) + 1;
    var pageNumber = this.currentPage;

    // console.log('Displaying page(this.currentPage): ' + this.currentPage);
    // console.log('Displaying page: ' + pageNumber);
     // console.log('Displaying filter:' + JSON.stringify(this.filter));

    this.spinner.show();
    this.promosService.getPromosByCamp(this.idCamp, pageNumber)
      .subscribe(
        (promoResult: PromoResult) => {
          // console.log('promoResult -> COUNT: ' + promoResult.count);
          // console.log('promoResult -> hasPrev: ' + promoResult.hasPrevPage);
          // console.log('promoResult -> hasNext: ' + promoResult.hasNextPage);
          this.promos = promoResult.promotions;
          this.promosService.setPromos(promoResult.promotions);

          if(promoResult.hasNextPage)
          {
            this.disabledOnNextButton=false;
          }
          else{
            this.disabledOnNextButton=true;
          }

          this.disabledOnPrevButton =  !promoResult.hasPrevPage;

          this.setPagination(pageNumber, promoResult.pages);
          this.spinner.hide();
        }
      );

  }


  getMobilePromos(){

    this.promosService.getPromosByCampAll(this.idCamp)
      .subscribe(
        (promoResult: PromoResult) => {

          // console.log('promoResult(Mobile) -> records: ' + promoResult.records);
          // console.log('promoResult(Mobile) -> pages: ' + promoResult.pages);
          // console.log('promoResult(Mobile) -> COUNT: ' + promoResult.count);
          // console.log('promoResult(Mobile) -> hasPrev: ' + promoResult.hasPrevPage);
          // console.log('promoResult(Mobile) -> hasNext: ' + promoResult.hasNextPage);

          this.promosMobile = promoResult.promotions;
          this.promosService.setPromosMobile(promoResult.promotions);

        }
      );

  }

  showPage(pageNumber: number) {

    // let pageNumber = (Number)((<HTMLImageElement>event.target).id);

    this.currentPage=pageNumber;

    console.log('Displaying page: ' + pageNumber);

    this.spinner.show();
    this.promosService.getPromosByCamp(this.idCamp, pageNumber)
      .subscribe(
        (promoResult: PromoResult) => {
          // console.log('promoResult -> COUNT: ' + promoResult.count);
          // console.log('promoResult -> hasPrev: ' + promoResult.hasPrevPage);
          // console.log('promoResult -> hasNext: ' + promoResult.hasNextPage);
          this.promos = promoResult.promotions;
          this.promosService.setPromos(promoResult.promotions);

          this.disabledOnPrevButton =  !promoResult.hasPrevPage;
          this.disabledOnNextButton =  !promoResult.hasNextPage;

          this.setPagination(pageNumber, promoResult.pages);
          this.spinner.hide();
        }
      );

  }

  goToLink(url: string, target: number, promoName: string){

    //--------------Call Google Analytics Event
    this.googleAnalyticsService.eventEmitter('Promociones', this.campaign.nombre,  'Informativa (' + this.campaign.nombre + '): Bancoppel - ' + promoName, 1);
    //--------------Call Google Analytics 4 Event
    this.eventGA4PushInteractions('bancoppel_promociones', this.campaign.nombre,  'Informativa (' + this.campaign.nombre + '): Bancoppel - ' + promoName);

    if(target===2)
      window.open(url, "_blank");
    else
      window.location.href=  url;
  }


  eventGA4PushInteractions(event: string, card_campaign_sendingmean: string, labelValue: string) {

    // console.log('Registering event in GA4: ' + event);

    if (event === 'bancoppel_promociones') {
      (<any>window).dataLayer.push({
        event: event,
        card_campaign: card_campaign_sendingmean,
        promo_name: labelValue
      });
    } else if (event === 'bancoppel_banners') {
      (<any>window).dataLayer.push({
        event: event,
        card_campaign_banners: card_campaign_sendingmean,
        banner_name: labelValue
      });
    } else if (event === 'social_share') {
      (<any>window).dataLayer.push({
        event: event,
        sending_mean: card_campaign_sendingmean,
        promo_name_ss: labelValue
      });
    }
  }



}
